import { render } from "./ColliBoxIcon.vue?vue&type=template&id=1a50c0e0"
import script from "./ColliBoxIcon.vue?vue&type=script&lang=js"
export * from "./ColliBoxIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__